import { Outlet, createBrowserRouter } from 'react-router-dom';

import NotFound from '@/pages/404/404.tsx';
import { ExternalBooking } from '@/pages/ExternalBooking.tsx';
import { Statistics } from '@/pages/Statistics.tsx';
import About from '@/pages/about/about';
import AllBookings from '@/pages/all-bookings/all-bookings';
import CarAccess from '@/pages/car-access/car-access';
import Help from '@/pages/help/help.tsx';
import Login from '@/pages/login/Login.tsx';
import Main from '@/pages/main/main';
import ObjectTypes from '@/pages/object-types/object-types';
import Objects from '@/pages/objects/objects.tsx';
import PassTypes from '@/pages/pass-types/pass-types';
import Passes from '@/pages/passes/passes';
import RatedBookings from '@/pages/rated-bookings/RatedBookings.tsx';
import Rating from '@/pages/rating/Rating';
import References from '@/pages/references/references';
import Renters from '@/pages/renters';
import Restrictions from '@/pages/restrictions/restrictions.tsx';
import ScudMapping from '@/pages/scud-mapping';
import Security from '@/pages/security/security';
import Settings from '@/pages/settings/Settings.tsx';
import Unauthorized from '@/pages/unauthorized/unauthorized.tsx';

import { AdminRoutes } from '@/router/AdminRoutes.tsx';
import { ModeratorRoutes } from '@/router/ModeratorRoutes.tsx';
import ProtectedRoute from '@/router/ProtectedRoute.tsx';
import { ReportsRoutes } from '@/router/ReportsRoutes.tsx';
import { ScudMappingRoutes } from '@/router/ScudMappingRoutes.tsx';

import { AppContextProvider } from '@/contexts/AppContext/AppContextProvider';

import HelpItem from '@/entities/Help/HelpItem.tsx';

import { EditBooking } from '@/features/EditBooking/EditBooking.tsx';
import { NewBooking } from '@/features/NewBooking';

import { BookUp } from '@/widgets/BookUp';
import { PersonalPlacesList } from '@/widgets/PersonalPlaces/PersonalPlacesList';
import ActiveBookingMore from '@/widgets/activeBooking';

import AdminLayout from '@/shared/layouts/AdminLayout';

import { AppRoutes } from './routes';

const WITH_SSO = import.meta.env.VITE_SSO === 'true';

const router = createBrowserRouter(
	[
		{
			path: '/',
			element: <ProtectedRoute />,
			errorElement: <NotFound />,
			children: [
				{
					path: '/',
					element: (
						<AppContextProvider>
							<Outlet />
						</AppContextProvider>
					),
					children: [
						{
							path: '/',
							element: <Main />,
							children: [
								{
									path: '/',
									element: <BookUp />,
								},
								{
									path: AppRoutes.Settings,
									element: <Settings />,
								},
								{
									path: AppRoutes.Bookings,
									element: <ActiveBookingMore />,
								},
								{
									path: AppRoutes.BookingNew,
									element: <NewBooking />,
								},
								{
									path: `${AppRoutes.Bookings}/:id/detail`,
									element: <EditBooking />,
								},
								{
									path: `${AppRoutes.Bookings}/:id/edit`,
									element: <EditBooking />,
								},
								{
									path: AppRoutes.Rating,
									element: <Rating />,
								},
								{
									path: AppRoutes.PersonalPlaces,
									element: <PersonalPlacesList />,
								},
								{
									path: AppRoutes.About,
									element: <About />,
								},
								{
									path: AppRoutes.Help,
									element: <Help />,
								},
								{
									path: `${AppRoutes.Help}/:id`,
									element: <HelpItem />,
								},
							],
						},
						/*Администрирование — отдельный лейаут без левого блока*/
						{
							path: '/',
							element: <AdminLayout />,
							children: [
								/*ModeratorRoutes*/
								{
									path: '/',
									element: <ModeratorRoutes />,
									children: [
										{
											path: AppRoutes.AllBookings,
											element: <AllBookings />,
										},
										{
											path: AppRoutes.Security,
											element: <Security />,
										},
										{
											path: AppRoutes.CarAccess,
											element: <CarAccess />,
										},
										{
											path: AppRoutes.Restrictions,
											element: <Restrictions />,
										},
										{
											path: AppRoutes.RatedBookings,
											element: <RatedBookings />,
										},
										{
											path: AppRoutes.Objects,
											element: <Objects />,
										},
									],
								},
								/*AdminRoutes*/
								{
									path: '/',
									element: <AdminRoutes />,
									children: [
										{
											path: AppRoutes.Passes,
											element: <Passes />,
										},
										{
											path: AppRoutes.PassTypes,
											element: <PassTypes />,
										},
										{
											path: AppRoutes.Vocabulary,
											element: <ObjectTypes />,
										},
										{
											path: AppRoutes.References,
											element: <References />,
										},
										{
											path: AppRoutes.Renters,
											element: <Renters />,
										},
									],
								},
								/*ReportsRoutes*/
								{
									path: '/',
									element: <ReportsRoutes />,
									children: [
										{
											path: AppRoutes.Statistics,
											element: <Statistics />,
										},
									],
								},
								/*ScudMappingRoutes — охрана по локациям из сервисных пропусков и администраторы*/
								{
									path: '/',
									element: <ScudMappingRoutes />,
									children: [
										{
											path: AppRoutes.ScudMapping,
											element: <ScudMapping />,
										},
									],
								},
							],
						},
					],
				},
			],
		},
		{
			path: '/login',
			element: WITH_SSO ? <Login /> : <Unauthorized />,
		},
		{
			path: `/booking/invite/:id`,
			element: <ExternalBooking />,
		},
	],
	// { basename: '/booking' },
);
export default router;
